<template lang="html">
  <el-container style="position:absolute;width:100%;">
    <el-aside width="180px">
      <div class="logo">
        {{show.title}}
      </div>
      <Aside />
    </el-aside>
    <el-container>
      <el-header>
        <div class="header">
          <el-row :gutter="25" type="flex" align="middle">
            <el-col>
              <div class="bell">
                <el-badge :hidden="true" :value="3" class="item">
                  <i class="el-icon-message-solid" size="small" />
                </el-badge>
              </div>
            </el-col>
            <el-col>
              <el-dropdown class="dropdown">
                <span class="el-dropdown-link">
                  <el-avatar size="small" :src="userAvatar"></el-avatar>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>修改密码</el-dropdown-item>
                  <el-dropdown-item>退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer></el-footer>
    </el-container>
  </el-container>
</template>

<script>
  import Aside from './aside.vue'
  import store from '../store/index'
  export default {
    components: {
      Aside
    },
    data () {
      return {
        show: {},
        userAvatar: null
      }
    },
    computed: {
      getWechatProfile () {
        return store.state.wechatProfile
      }
    },
    watch: {
      getWechatProfile (val) {
        if (val) {
          this.userAvatar = val.headimgurl
        }
      }
    },
    mounted () {
      let that = this
      that.$api.show.detail(that.$route.params.slug).then(res => {
        that.show = res.data
        document.title = `${res.data.title}管理后台`
      })
    }
  }

</script>

<style lang="css" scoped>
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
  .el-container {
    height: 100%;
  }
  .el-header {
    padding: 0;
    background: #fff;
  }
  .el-aside {
    background: #303133;
  }
  .el-main {
    background: #f5f6fa;
  }
  .el-footer {
    background: #f5f6fa;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #999;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  /* header */
  el-header {
  }
  .header {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 25px;
  }
  .dropdown {
    font-size: 12px;
  }
  .bell {
    font-size: 23px;
    color: #999;
  }
</style>
